import TicketsForm from './TicketsForm'
import TicketsFormContainer from './TicketsFormContainer'

export default TicketsFormContainer(TicketsForm)
